import { ApiResponse, post } from "../helpers";
import {
  DashboardTileModel,
  GetParticipantCSOStatsResponse,
  GetParticipantStatsRequest,
  GetParticipantStatsResponse,
  GetRegistrationBarChartRequest,
  GetRegistrationBarChartResponse,
} from "../models/dashboardModel";
import { DashboardEndPoints } from "./configEndPoints";

// eslint-disable-next-line @typescript-eslint/naming-convention
const GetTiles = async (): Promise<ApiResponse<DashboardTileModel>> => {
  return post<string, DashboardTileModel>(DashboardEndPoints.GetTiles, "");
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const GetParticipantStats = async (
  id: number
): Promise<ApiResponse<GetParticipantStatsResponse>> => {
  return post<GetParticipantStatsRequest, GetParticipantStatsResponse>(
    DashboardEndPoints.GetParticipantStats,
    { hierarchyLevel3Id: id } as GetParticipantStatsRequest
  );
};

const GetRegistrationBarChart = async (
  id: number
): Promise<ApiResponse<GetRegistrationBarChartResponse>> => {
  return post<GetRegistrationBarChartRequest, GetRegistrationBarChartResponse>(
    DashboardEndPoints.GetRegistrationBarChart,
    { hierarchyLevel3Id: id } as GetRegistrationBarChartRequest
  );
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const GetParticipantCSOStats = async (
  id: number
): Promise<ApiResponse<GetParticipantCSOStatsResponse>> => {
  return post<GetParticipantStatsRequest, GetParticipantCSOStatsResponse>(
    DashboardEndPoints.GetParticipantCSOStats,
    { hierarchyLevel3Id: id } as GetParticipantStatsRequest
  );
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const DashboardApi = {
  GetTiles,
  GetParticipantStats, // add new function to API
  GetRegistrationBarChart,
  GetParticipantCSOStats,
};

export default DashboardApi;
